export default __webpack_public_path__ + "static/media/about-benefits-category.2e2e2be4.jpg";